var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-course-by-self"},[_c('table-list',{attrs:{"title":"课程列表","loading":_vm.loading,"data":_vm.courseList,"search-form":_vm.searchForm(this),"columns":_vm.columns(this),"pager":_vm.pager,"btns":_vm.btns(this),"options":{
      selection: true,
      reserveSelection: true,
      rowKey: 'courseId',
      selectable: _vm.selectEvent,
    }},on:{"search":_vm.onSearch,"selectionChange":_vm.handleSelectionChange,"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }